import dateFormat from 'dateformat';
import dayjs from 'dayjs';
import configData from '../config.json';
import { appNotificationsTypes, JOB_STATUS } from './constants';
import { setNotification } from '../actions/appNotifications';
import { rateEnum } from './enums';

export const sortArrayOfObjectsByDate = (array, prop, additionalProp1, additionalProp2) => {
  const sortedArray = array.sort((current, next) =>
    // eslint-disable-next-line no-nested-ternary
    new Date(current[prop]) === new Date(next[prop]) ? 0 : new Date(current[prop]) > new Date(next[prop]) ? -1 : 1
  );

  if (additionalProp1 && additionalProp2) {
    return [
      ...sortArrayOfObjectsByDate(
        array.filter((item) => item[additionalProp1]),
        additionalProp2
      ),
      ...sortedArray.filter((item) => !item[additionalProp1])
    ];
  }
  return sortedArray;
};

export const validatePBData = (data) => {
  const errors = {
    JobExperienceDetails: [],
    EducationDetails: [],
    TrainingDetails: [],
    RequireAtLeastOneItem: []
  };
  data.JobExperienceDetails?.forEach((job) => {
    if (!job.Title || !job.EmployerName || !job.Description || !job.StartDate) errors.JobExperienceDetails.push(job);
  });

  data.EducationDetails?.forEach((edu) => {
    if (!edu.SchoolName || !edu.Degree?.Name || !edu.Major || !edu.StartDate || !edu.EndDate)
      errors.EducationDetails.push(edu);
  });

  data.TrainingDetails?.forEach((training) => {
    if (!training.CertificationType) errors.TrainingDetails.push(training);
  });

  /* Tenporarily comented because of requirements from POs */
  // if (!data?.EducationDetails?.length) {
  //   errors.RequireAtLeastOneItem.push('Education');
  // } else {
  //   errors.RequireAtLeastOneItem = errors.RequireAtLeastOneItem.filter((item) => item !== 'Education');
  // }

  return errors;
};

export const correctData = (obj, dayOffset = 0) => {
  const newObj = { ...obj };
  let startDate = new Date(newObj.StartDate);
  startDate.setDate(startDate.getDate() + dayOffset);
  startDate = dateFormat(startDate, 'isoUtcDateTime');
  let endDate = new Date(newObj.EndDate);
  endDate.setDate(endDate.getDate() + dayOffset);
  endDate = dateFormat(endDate, 'isoUtcDateTime');

  if (newObj.ValidUntil) {
    let validUntil = new Date(newObj.ValidUntil);
    validUntil.setDate(validUntil.getDate() + dayOffset);
    validUntil = dateFormat(validUntil, 'isoUtcDateTime');

    delete newObj.StartDate;
    delete newObj.EndDate;

    return { ...newObj, ValidUntil: validUntil };
  }

  return { ...newObj, StartDate: startDate, EndDate: endDate };
};

// eslint-disable-next-line no-restricted-globals
export const isValidDate = (date) => date instanceof Date && !isNaN(date);

export const increaseDate = (date, numberOfDays) => {
  if (!isValidDate(new Date(date))) return undefined;

  let increasedDate = new Date(date);
  increasedDate.setDate(increasedDate.getDate() + numberOfDays);
  increasedDate = dateFormat(increasedDate, 'isoUtcDateTime');

  return increasedDate;
};

export const withDebounce = (func, delay, timerId, setTimer) => {
  if (timerId) {
    clearTimeout(timerId);
  }
  const timerDelayId = setTimeout(() => {
    setTimer(null);
    func();
  }, delay);
  setTimer(timerDelayId);
};

export const isJobActive = (item) => {
  if (item && item.Job) {
    if (!item.Job.IsActive) {
      return false;
    }
  }

  return true;
};

export const getLastDayOFMounth = (dateString) => {
  const date = new Date(dateString);
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export const getFirstDayOFMonth = (dateString) => {
  const date = new Date(dateString);
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const parseAPIErrors = (errors) => {
  return Object.entries(errors).map((error) => {
    const block = error[0].substring(0, error[0].indexOf('['));
    const numberOfEntries = error[0].substring(error[0].indexOf('[') + 1, error[0].indexOf(']'));
    const property = error[0].substring(error[0].indexOf('.') + 1, error[0].length);
    const messages = error[1].join('/');
    return block
      ? `${block} -> Entry number: ${
          Number(numberOfEntries) + 1
        } -> Field: ${property}, has the following errors: ${messages}`
      : `Field: ${property}, has the following errors: ${messages}`;
  });
};

export const getCookie = (name) => {
  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${name?.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`)
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const checkOnboardingCookie = () => {
  return getCookie(configData.TIFO_ONBOARDING_KEY)
    ? getCookie(configData.TIFO_ONBOARDING_KEY) === configData.TIFO_ONBOARDING_VALUE
    : false;
};

export const checkTandECookie = () => {
  return getCookie(configData.TandE_COOKIE_KEY)
    ? getCookie(configData.TandE_COOKIE_KEY) === configData.TandE_COOKIE_VALUE
    : false;
};

export const checkTandEApproverCookie = () => {
  return getCookie(configData.TandE_APPROVER_COOKIE_KEY)
    ? getCookie(configData.TandE_APPROVER_COOKIE_KEY) === configData.TandE_APPROVER_COOKIE_VALUE
    : false;
};

export const removeStyleAttribute = (htmlString) => {
  const regex = /style="[^"]*"/gi;
  return htmlString.replace(regex, '');
};

export const getNumberWithDelimeter = (num, isEdit) => {
  if (Number(num) === 0) return 0;
  return Number.isInteger(Number(num)) && isEdit ? `${num}.00` : num;
};

export const getHoursAndMinutes = (incomingHours) => {
  const hours = Number(parseFloat(incomingHours).toFixed(2).toString());
  const minutes = (hours - Math.trunc(hours)) * 60;
  return `${Math.trunc(hours)} h ${minutes !== 0 ? `${Math.floor(minutes)} m` : ''}`;
};

export const getValuesByKey = (initArray, originalKey, fromArray, byKey) => {
  const uniqArray = Array.from(new Set(initArray.map((item) => item?.[originalKey])));

  if (uniqArray.indexOf(undefined) === 0) {
    return initArray.map((item) => fromArray.find((value) => value?.[byKey] === item));
  }

  return uniqArray.map((item) => fromArray.find((value) => value?.[byKey] === item));
};

export const setClassForStatusBubble = (status, style) => {
  switch (status) {
    case JOB_STATUS.CLOSED:
      return style.grayAppliedTag;
    case JOB_STATUS.APPLIED:
      return style.appliedTag;
    default:
      return style.otherTag;
  }
};

export const createLinkForSharingJob = (ref, id) => `${ref}/jobs/${id}`;

export const stringToHslColor = (str, s, l) => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const h = hash % 360;
  return `hsl(${h}, ${s}%, ${l}%)`;
};

export const buildMonth = (actualDate) => {
  const firstDayOfTheMonth = actualDate?.clone().startOf('month');

  const firstDayOfFirstWeekOfMonth = dayjs(firstDayOfTheMonth).startOf('week');

  const generateFirstDayOfEachWeek = (day) => {
    const dates = [day];
    for (let i = 1; i < 6; i++) {
      const dateFD = day.clone().add(i, 'week');
      dates.push(dateFD);
    }
    return dates;
  };

  const generateWeek = (day) => {
    const dates = [];
    for (let i = 1; i < 8; i++) {
      const dateW = day.clone().add(i, 'day').toDate();
      dates.push(dateW);
    }
    return dates;
  };

  const generateWeeksOfTheMonth = () => {
    const firstDayOfEachWeek = generateFirstDayOfEachWeek(firstDayOfFirstWeekOfMonth);
    return firstDayOfEachWeek.map((dateFDEW) => generateWeek(dateFDEW));
  };

  return generateWeeksOfTheMonth().filter((week) =>
    week.some((day) => day.getMonth() === new Date(firstDayOfTheMonth).getMonth())
  );
};

export const isValidByRateType = (value, type) => {
  const numberValue = Number(value);
  if (type === rateEnum.HOURLY && numberValue >= 0 && numberValue <= 24) return true;
  return type === rateEnum.DAILY && numberValue >= 0 && numberValue <= 1;
};

export const removeDuplicates = (arr) => {
  const tempObj = {};
  return arr.filter((obj) => {
    const key = JSON.stringify(obj);
    if (!tempObj[key]) {
      tempObj[key] = true;
      return true;
    }
    return false;
  });
};

export const checkRoleInLS = (param) => {
  const data = localStorage.getItem('restoreAccess');
  if (data) {
    return JSON.parse(data)[param];
  }
  return false;
};

export const basicErrorHandler = (dispatch, message, type = appNotificationsTypes.ERROR, duration = 3000) => {
  return dispatch(
    setNotification({
      type,
      message,
      duration
    })
  );
};

export const distanceDateFormat = (inputDate, isUTC = false) => {
  const now = isUTC ? dayjs().add(-dayjs().utcOffset(), 'minutes') : dayjs();
  const secondsDiff = now.diff(inputDate, 'second');

  if (secondsDiff < 60) {
    return `A few seconds ago`;
  }
  if (secondsDiff > 60 && secondsDiff < 3600) {
    const minutes = Math.floor(secondsDiff / 60);
    return `${minutes} minutes ago`;
  }
  if (secondsDiff > 3600 && secondsDiff < 86400) {
    const hours = Math.floor(secondsDiff / 3600);
    return `${hours} hour ago`;
  }
  if (secondsDiff > 86400 && secondsDiff < 172800) {
    return `Yesterday`;
  }

  return `${dayjs(inputDate).format('MMM D')}`;
};

export const convertToFormData = (json) => {
  const formData = new FormData();

  Object.entries(json).forEach((item) => {
    if (item[1] !== null) {
      formData.append(item[0], item[1]);
    }
  });

  return formData;
};

export const getBlobDetails = (values, file) => {
  const { DOMAIN, BLOB_CONTAINER, SASS_TOKEN } = values;
  const blobUrlForAttachment = `${DOMAIN}/${BLOB_CONTAINER}/${file}${SASS_TOKEN}`;
  const fileExtension = file?.split('.')?.pop()?.toLowerCase();

  return {
    uri: blobUrlForAttachment,
    ext: fileExtension
  };
};

export const generateWeekBySundayDate = (date) => {
  const week = [];
  for (let i = 0; i < 7; i++) {
    week.push(new Date(date.add(-i, 'day').toString()));
  }
  return week.reverse();
};

export const numberWithCommas = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const clearMonth = (data, currentMonth) => {
  return data.map((item) => ({
    ...item,
    TimesheetHoursByDates: item.TimesheetHoursByDates.reduce((acc, elem) => {
      if (dayjs(elem.Day).month() === currentMonth) {
        return [...acc, elem];
      }
      return acc;
    }, [])
  }));
};

export const getSerializedSearchParams = () => {
  let oldSearchParams = {};

  const searchParams = new URLSearchParams(window.location.search.slice(1));
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of searchParams.entries()) {
    oldSearchParams = {
      ...oldSearchParams,
      [key]: value
    };
  }

  return oldSearchParams;
};
